import React, { Component } from 'react';

const SubscriptionConfirmation = () => {
  
    return (
      <h1>Subscription Confirmation</h1>
    );
};

export default SubscriptionConfirmation;